



import { BaseEntityResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEntitiesResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDataResponse } from '@m4u-angular/base/entities/BaseEntities';
import { BaseResponse } from '@m4u-angular/base/entities/BaseEntities';
import { GenericListEntity } from '@m4u-angular/base/entities/BaseEntities';
import { DataGroupInfo } from '@m4u-angular/base/entities/BaseEntities';
import { BaseEndpoint } from '@m4u-angular/base/endpoint/BaseEndpoint';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { APIGatewayService } from '@m4u-angular/core/gateway/APIGateway.service';
import { EnumRequestProgressTracking } from '@m4u-angular/core/framework/sysenums.enum';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { File } from './../entities/file.entity';
import { DocumentsDownloadParams } from '../params/documentsdownload.param';
@Injectable()
export class FileEndpoint extends BaseEndpoint
{
    constructor(api: APIGatewayService) {super("File", api);}
	

    public  GetList(iObjectType: number, iDocEntry: number) : Observable<BaseEntitiesResponse<File>>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetList',  {iObjectType: iObjectType, iDocEntry: iDocEntry} );
    }

    public  GetFileData(iEntryID: number) : Observable<Blob>
	{
		return this.api.ExecuteGetAction(this.ControllerName, 'GetFileData',  {iEntryID: iEntryID} , undefined, 'blob');
    }
    public GetAllDocumentsPdfData(param: DocumentsDownloadParams): Observable<BaseDataResponse<any>>
    {
        return this.api.ExecutePostAction(this.ControllerName, 'GetAllDocumentsPdfData', param);
    }
}

